<template>
    <div>
        <TableLoading
            v-if="isLoading"
            :class="`mt-2 ${skeletonClass}`"
            rowHeight="55"
            :rows="skeletonRows"
        />
        <div v-else class="mb-5">
            <div v-if="hasTable">
                <slot></slot>
                <PaginationButtons
                    :multiply="totalPerPage"
                    :pagination="pagination"
                    @next="updatePage($event)"
                    @prev="updatePage($event)"
                />
            </div>
        </div>
    </div>
</template>

<script>
// Components
import PaginationButtons from '@/components/pagination/PaginationButtons.vue';
import TableLoading from '@/components/loading/TableLoading.vue';
export default {
    name: 'TableContainer',
    props: {
        isLoading: {
            type: Boolean,
            required: true,
            default: false
        },
        skeletonRows: {
            type: [String, Number],
            default: 20
        },
        pagination: {
            type: Object,
            required: true
        },
        totalPerPage: {
            type: [String, Number],
            default: 20
        },
        hasTable: {
            type: Boolean,
            required: true,
            default: true
        },
        skeletonClass: {
            type: String,
            required: false,
            default: '',
        },
    },
    components: {
        PaginationButtons,
        TableLoading
    },
    methods: {
        async updatePage(page) {
            this.$emit('updatePage', page)
        },
    },
}
</script>

<style>
</style>